import dayjs from "dayjs";

import { formatIdentifier } from "@/utils/formatIdentifier";
import { phoneFormat } from "@/utils/formatPhone";
import { addressConcat } from "@/utils/adreessConcat";
import { getAge } from "@/utils/dateUtil";
import { DetailedCitizenAcsVisitsIndicatorC5Data } from "@/services/esus/indicator/esf/c5/getDetailedCitizensAcsVisitsIndicatorC5";

import { TimeLine, TimeLineContent } from "@/components/TimeLine";
import { IndicatorEsfC5CitizensAcsVisitsHistoryItem } from "./IndicatorEsfC5CitizensAcsVisitsHistoryItem";
import { IndicatorEsfC5CitizensAcsVisitsHistoryInfo } from "./IndicatorEsfC5CitizensAcsVisitsHistoryInfo";

type IndicatorEsfC5CitizensAcsVisitsHistoryProps = {
	citizenWithAcsHomeVisits: DetailedCitizenAcsVisitsIndicatorC5Data;
};

export function IndicatorEsfC5CitizensAcsVisitsHistory({
	citizenWithAcsHomeVisits,
}: Readonly<IndicatorEsfC5CitizensAcsVisitsHistoryProps>) {
	const indicatorEsfC5CitizenHistoryInfo = {
		fullName: citizenWithAcsHomeVisits.fullName ? citizenWithAcsHomeVisits.fullName : "N/A",
		birthdate: citizenWithAcsHomeVisits.birthdate
			? dayjs(citizenWithAcsHomeVisits.birthdate).format("DD/MM/YYYY")
			: "N/A",
		age: citizenWithAcsHomeVisits.birthdate
			? getAge(citizenWithAcsHomeVisits.birthdate)
			: "N/A",
		document: citizenWithAcsHomeVisits.cpf
			? formatIdentifier(citizenWithAcsHomeVisits.cpf)
			: citizenWithAcsHomeVisits.cns ?? "",
		motherName: citizenWithAcsHomeVisits.motherName ?? "",
		phone: citizenWithAcsHomeVisits.phone ? phoneFormat(citizenWithAcsHomeVisits.phone) : "",
		address:
			addressConcat(
				citizenWithAcsHomeVisits.street,
				citizenWithAcsHomeVisits.houseNumber,
				citizenWithAcsHomeVisits.neighborhood
			) ?? "",
	};

	return (
		<>
			<IndicatorEsfC5CitizensAcsVisitsHistoryInfo {...indicatorEsfC5CitizenHistoryInfo} />
			<TimeLine
				timeLineTitle="Visitas"
				timeLineContents={[
					citizenWithAcsHomeVisits.firstAcsHomeVisit,
					citizenWithAcsHomeVisits.lastAcsHomeVisit,
				]
					.filter((homeVisit) => Boolean(homeVisit))
					.map((homeVisit) => homeVisit!)
					.map<TimeLineContent>((homeVisit) => {
						return {
							content: (
								<IndicatorEsfC5CitizensAcsVisitsHistoryItem homeVisit={homeVisit} />
							),
							eventDate: homeVisit.date
								? dayjs(homeVisit.date).format("DD/MM/YYYY")
								: "N/A",
						};
					})}
			/>
		</>
	);
}
